export const AFFORDABLE_DETAILS = {
  SUBTITLE:
    'Let prospects know the guidelines and details of the Affordable housing program for this property. This may include income limits, eligibility criteria, or rent restrictions.',

  TITLE: 'Program Overview & Details',
};

export const INCOME_ELIGIBILITY = {
  SUBTITLE:
    'Enter the maximum allowable income for each household size to define eligibility for affordable housing at this property.',
  TITLE: 'Household Income Eligibility',
};

export const CONFIRMATION_MODES = {
  UNSAVED: 'unsaved',
  UPDATE: 'update',
};

export const CONFIRMATION_BUTTON_TEXT = {
  [CONFIRMATION_MODES.UNSAVED]: 'Yes, Save',
  [CONFIRMATION_MODES.UPDATE]: 'Save Changes',
};
export const CONFIRMATION_SECONDARY_BUTTON_TEXT = {
  [CONFIRMATION_MODES.UNSAVED]: 'No, Leave',
};

export const CONFIRMATION_MESSAGES = {
  [CONFIRMATION_MODES.UNSAVED]:
    'You have unsaved changes that will be lost if you leave this section.',
  [CONFIRMATION_MODES.UPDATE]:
    'Saving will overwrite any current program details and specified incomes. This change cannot be undone.',
};

export const CONFIRMATION_TITLES = {
  [CONFIRMATION_MODES.UNSAVED]: 'Save Changes?',
  [CONFIRMATION_MODES.UPDATE]: 'Update Program Details',
};
